import { button, heading, mailColors, mailFrame, paragraphs, row, type MailFrameContext } from '../newsletter/newsletterHtml'
import { effectiveMailText, exampleValues, fillVariables } from '../../core/rules/mail'
import { brandColors as c } from '../../data/brandColors'
import type { MailSeries, MailTemplate } from '../../core/types/mail'

/**
 * Voorbeeld van een automatische mail in dezelfde huisstijl als de nieuwsbrief. Laravel bouwt de
 * echte mail met dezelfde opbouw (beslissing M2); dit is wat Sarah ziet en wat de testmail toont.
 * Invulvelden krijgen hun voorbeeldwaarde.
 */
export function mailPreviewHtml(m: MailTemplate | MailSeries, ctx: MailFrameContext): { html: string; subject: string; preheader: string } {
  const values = exampleValues(m.variables)
  const text = effectiveMailText(m)
  const fill = (s: string) => fillVariables(s, values)
  const blocks = text.blocks
    .filter((b) => b.heading.trim() || b.body.trim())
    .map((b) => row(`${b.heading.trim() ? heading(fill(b.heading)) : ''}${paragraphs(fill(b.body), c.ink)}`))
  const link = m.button ? values[m.button.variable] : ''
  const k = mailColors(ctx.brand)
  if (m.button && m.button.label.trim()) blocks.push(row(button(fill(m.button.label), link, k.button, k.buttonText), '8px 36px 28px'))
  const subject = fill(text.subject)
  const preheader = fill(text.preheader)
  return { html: mailFrame({ subject, preheader, body: blocks.join('\n'), kind: 'transactional' }, ctx), subject, preheader }
}
